exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-page {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  padding: 40px 0;\n}\n@media (max-width: 900px) {\n  .asset-page {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n}\n.asset-page .flex-grow {\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/assets-page/assets-page.component.scss
// module id = ../../../../../src/app/pages/assets-page/assets-page.component.scss
// module chunks = main